/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { JoysticksSettings } from "../../../../gen/joysticks/joysticks_settings";

export const protobufPackage = "skills";

export interface UpdateJoysticksSettingsActionArgs {
  settings: JoysticksSettings | undefined;
  checkSettingsAreApplied: boolean;
}

export interface UpdateJoysticksSettingsResultData {
}

export interface UpdateJoysticksSettingsActionStateData {
}

function createBaseUpdateJoysticksSettingsActionArgs(): UpdateJoysticksSettingsActionArgs {
  return { settings: undefined, checkSettingsAreApplied: false };
}

export const UpdateJoysticksSettingsActionArgs = {
  encode(message: UpdateJoysticksSettingsActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.settings !== undefined) {
      JoysticksSettings.encode(message.settings, writer.uint32(10).fork()).ldelim();
    }
    if (message.checkSettingsAreApplied === true) {
      writer.uint32(16).bool(message.checkSettingsAreApplied);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateJoysticksSettingsActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateJoysticksSettingsActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.settings = JoysticksSettings.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.checkSettingsAreApplied = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateJoysticksSettingsActionArgs {
    return {
      settings: isSet(object.settings) ? JoysticksSettings.fromJSON(object.settings) : undefined,
      checkSettingsAreApplied: isSet(object.checkSettingsAreApplied)
        ? globalThis.Boolean(object.checkSettingsAreApplied)
        : false,
    };
  },

  toJSON(message: UpdateJoysticksSettingsActionArgs): unknown {
    const obj: any = {};
    if (message.settings !== undefined) {
      obj.settings = JoysticksSettings.toJSON(message.settings);
    }
    if (message.checkSettingsAreApplied === true) {
      obj.checkSettingsAreApplied = message.checkSettingsAreApplied;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateJoysticksSettingsActionArgs>, I>>(
    base?: I,
  ): UpdateJoysticksSettingsActionArgs {
    return UpdateJoysticksSettingsActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateJoysticksSettingsActionArgs>, I>>(
    object: I,
  ): UpdateJoysticksSettingsActionArgs {
    const message = createBaseUpdateJoysticksSettingsActionArgs();
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? JoysticksSettings.fromPartial(object.settings)
      : undefined;
    message.checkSettingsAreApplied = object.checkSettingsAreApplied ?? false;
    return message;
  },
};

function createBaseUpdateJoysticksSettingsResultData(): UpdateJoysticksSettingsResultData {
  return {};
}

export const UpdateJoysticksSettingsResultData = {
  encode(_: UpdateJoysticksSettingsResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateJoysticksSettingsResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateJoysticksSettingsResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UpdateJoysticksSettingsResultData {
    return {};
  },

  toJSON(_: UpdateJoysticksSettingsResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateJoysticksSettingsResultData>, I>>(
    base?: I,
  ): UpdateJoysticksSettingsResultData {
    return UpdateJoysticksSettingsResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateJoysticksSettingsResultData>, I>>(
    _: I,
  ): UpdateJoysticksSettingsResultData {
    const message = createBaseUpdateJoysticksSettingsResultData();
    return message;
  },
};

function createBaseUpdateJoysticksSettingsActionStateData(): UpdateJoysticksSettingsActionStateData {
  return {};
}

export const UpdateJoysticksSettingsActionStateData = {
  encode(_: UpdateJoysticksSettingsActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateJoysticksSettingsActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateJoysticksSettingsActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UpdateJoysticksSettingsActionStateData {
    return {};
  },

  toJSON(_: UpdateJoysticksSettingsActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateJoysticksSettingsActionStateData>, I>>(
    base?: I,
  ): UpdateJoysticksSettingsActionStateData {
    return UpdateJoysticksSettingsActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateJoysticksSettingsActionStateData>, I>>(
    _: I,
  ): UpdateJoysticksSettingsActionStateData {
    const message = createBaseUpdateJoysticksSettingsActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
